import { Button, Group, Modal, Text } from '@mantine/core';

type ApproveConfirmModalProps = {
  opened: boolean;
  accountLabel: string;
  documentTypeLabel: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ApproveConfirmModal = ({
  opened,
  accountLabel,
  documentTypeLabel,
  isPending,
  onCancel,
  onConfirm,
}: ApproveConfirmModalProps) => (
  <Modal
    opened={opened}
    onClose={onCancel}
    title="確認審核成功"
    centered
    styles={{ title: { fontWeight: 700, fontSize: 16 } }}
  >
    <Text size="sm">
      確定將 {accountLabel} 的{documentTypeLabel}標記為「審核成功」？
    </Text>
    <Group justify="flex-end" mt="lg">
      <Button variant="outline" onClick={onCancel} disabled={isPending}>
        取消
      </Button>
      <Button onClick={onConfirm} loading={isPending}>
        確認
      </Button>
    </Group>
  </Modal>
);

export { ApproveConfirmModal };
